import React from 'react';
import clsx from 'clsx';
import I18n from 'i18n-js';
import { toIconSrc } from '../../Utils/icons';
import styles from './SlideHeader.module.scss';

interface SlideHeaderProps {
  locale: string;
  slide?: any;
}

const SlideHeader = ({ locale, slide }: SlideHeaderProps) => {
  const SLIDE_HEADER_STYLES = 'tw-flex tw-items-center tw-w-max tw-pl-4 tw-rounded-r-[100px] tw-relative '
    + 'tw-top-[10px] tw-gap-4 tw-font-black tw-border-solid tw-border-2 tw-border-l-0 tw-border-[#FFC50C] tw-h-8 '
    + 'tw-bg-white !tw-z-10';

  const hasPageNumbers = slide?.startPage || slide?.endPage;
  const slideGroupIconSrc = toIconSrc(slide?.slideGroupIcon);

  const getPageNumbers = () => {
    // If one page number is blank it is set to be equal to the other, so just one should show (eg. 42 to 42 => 42)
    if (slide?.startPage && slide?.endPage && !(slide?.startPage === slide?.endPage)) {
      return `${I18n.t('pages')} ${slide?.startPage} - ${slide?.endPage}`;
    }
    return `${I18n.t('page')} ${slide?.startPage || slide?.endPage}`;
  };

  return (
    <div
      className={clsx(SLIDE_HEADER_STYLES, 'slide-header', {
        'tw-pr-0': hasPageNumbers,
        'tw-pr-4': !hasPageNumbers,
      })}
    >
      <div className="tw-flex tw-items-center tw-justify-center tw-gap-2">
        {slideGroupIconSrc && <img alt="" className="tw-grayscale tw-h-7" src={slideGroupIconSrc} />}
        <div>{locale === 'en' ? slide?.slideGroupTitleEn : slide?.slideGroupTitleEs}</div>
      </div>

      {hasPageNumbers && (
        <div className="tw-flex tw-items-center">
          <div className={clsx(styles.ribbon, 'tw-h-8 tw-w-5 tw-bg-[#FFC50C]')} />
          <div
            className="tw-bg-[#ffeeb6] tw-flex tw-items-center tw-rounded-r-[100px] tw-pr-4 tw-pl-3 tw-h-8 tw-font-bold"
          >
            {getPageNumbers()}
          </div>
        </div>
      )}
    </div>
  );
};

export default SlideHeader;
